import { render, staticRenderFns } from "./MyReminder.vue?vue&type=template&id=6569d78d&"
import script from "./MyReminder.vue?vue&type=script&lang=js&"
export * from "./MyReminder.vue?vue&type=script&lang=js&"
import style0 from "./MyReminder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports